import React from 'react';
import { Modal } from '../ui/Modal';
import { InquiryForm } from './InquiryForm';
import { useTranslation } from '../../lib/i18n';
interface InquiryModalProps {
  isOpen: boolean;
  onClose: () => void;
  preselectedProductId?: string;
}
export function InquiryModal({
  isOpen,
  onClose,
  preselectedProductId
}: InquiryModalProps) {
  const {
    t
  } = useTranslation();
  return <Modal isOpen={isOpen} onClose={onClose} title={t.inquiry.title} maxWidth="lg" data-id="element-120">
      <InquiryForm preselectedProductId={preselectedProductId} onSuccess={onClose} data-id="element-121" />
    </Modal>;
}